module.exports = __webpack_public_path__ + "img/jr.2bc37664.png";